import axios from "axios";
import type { JobReference } from "../Services/JobRefreshCoordinator";
import { getUserFromLS } from "../utils/getUserFromLS";

export interface PromptRevisionChange {
  prompt_id: number;
  subject: string | null;
  message: string;
  explanation: string;
}

export interface SeriesRevision {
  client_id?: string | null;
  change_version?: number;
  requester_id?: string | null;
  job_reference?: JobReference | null;
  id: string;
  series_id: string;
  status: "queued" | "ready" | "no_changes" | "failed" | "applied" | "cancelled" | "conflict";
  request: { guidance: string; scope: "remaining" | "selected"; prompt_ids: number[] | null; idempotency_key: string };
  editable_prompt_ids: number[];
  snapshot: { prompts: { id: number; step_number: number; content_type: string; subject: string | null; message: string }[]; completed_prompt_ids: number[] };
  result: { changes: PromptRevisionChange[]; summary: string; failed: boolean } | null;
}

async function revisionRequest(seriesId: string, suffix: string, method: "GET" | "POST", data?: unknown): Promise<SeriesRevision> {
  const response = await axios({
    url: `${import.meta.env.VITE_API_BASE_URL}/social_prompts/series/${encodeURIComponent(seriesId)}/revisions${suffix}`,
    method,
    headers: { Authorization: `Bearer ${getUserFromLS().access_token}` },
    data,
  });
  return response.data;
}

export const requestSeriesRevision = (seriesId: string, data: SeriesRevision["request"]) => revisionRequest(seriesId, "", "POST", data);
export const getLatestSeriesRevision = async (seriesId: string): Promise<SeriesRevision | null> => revisionRequest(seriesId, "", "GET");
export const getSeriesRevision = (seriesId: string, revisionId: string) => revisionRequest(seriesId, `/${encodeURIComponent(revisionId)}`, "GET");
export const applySeriesRevision = (seriesId: string, revisionId: string) => revisionRequest(seriesId, `/${encodeURIComponent(revisionId)}/apply`, "POST");
export const cancelSeriesRevision = (seriesId: string, revisionId: string) => revisionRequest(seriesId, `/${encodeURIComponent(revisionId)}/cancel`, "POST");
